import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useAccount } from "@redux/account";
import { DefaultItem } from "@assets/papers";
import { DefaultLabel } from "@assets/label";
import { OutlinedInputDefault } from "@assets/TextField";
import { useInput } from "@assets/hooks";
import { passRule } from "@assets/utils/check";
import { maxLength } from "@assets/validators";
import { DefaultContainedButton, DefaultOutlinedButton } from "@assets/buttons";
import { useMenuState } from "@assets/contexts/MenuContext";
import { useAdvertiser } from "@redux/advertiser";

const CompProfile = () => {
  const value = useMenuState();
  const advertiser = useAdvertiser();
  const title = useInput("", maxLength); // 광고명
  const userId = useInput("", maxLength); // 아이디
  const email = useInput(""); // 광고명
  const navigate = useNavigate();
  const account = useAccount();
  const [loading, setLoading] = useState(true);

  const handlePageMove = () => {
    navigate("/", { replace: true });
  };

  const handleUpdate = () => {
    if (
      title.value === "" ||
      title.value === undefined ||
      title.value === null
    ) {
      alert("광고주 이름을 확인해주세요");
      return false;
    }
    if (
      email.value === "" ||
      email.value === undefined ||
      email.value === null
    ) {
      alert("광고주 이메일을 확인해주세요");
      return false;
    }
    if (!passRule.test(email.value)) {
      //경고
      alert("광고주 이메일을 확인해주세요");
      return false;
    }
    const totalData = {
      email: email.value,
      user_id: userId.value,
    };
    account.update(totalData, (data, response) => {
      if (response.status === 200) {
        if (data.error) {
          alert(data.error.message);
        } else {
          alert("수정완료 되었습니다.");
        }
      } else {
        if (!response.data || !response.data.error) {
          alert("에러가 발생하였습니다.");
        } else {
          alert(response.data.error.message);
        }
      }
    });
  };

  useEffect(() => {
    setLoading(true);
    if (value.user.ADMIN === null) {
      advertiser.info(value.user.AD[0], (data, response) => {
        if (response.status === 200 && data.error === undefined) {
          if (data.result) {
            title.onChangeVal(data.result.name);
            userId.onChangeVal(data.result.user_id);
            email.onChangeVal(
              data.result.email === undefined ||
                data.result.email === null ||
                !data.result.email
                ? ""
                : data.result.email
            );
          }
        } else {
          alert(data.error.message);
        }
      });
      setLoading(false);
    }
  }, []);
  // useEffect(() => {
  //   // console.log(value);
  //   console.log(value);
  //   // if (value.user.ADMIN === null) {
  //   //   console.log("a");
  //   //   advertiser.info(value.user.AD[0], (data, response) => {});
  //   // } else {
  //   //   console.log("b");
  //   // }

  //   // console.log("0-----");
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // console.log(value);
  return (
    <>
      {loading ? (
        <></>
      ) : (
        <Grid container justifyContent="center" direction="column">
          <Container maxWidth="lg" sx={{ pt: 7.75 }}>
            <Grid container justifyContent="center">
              <DefaultItem sx={{ boxShadow: 0, height: "100%", width: 630 }}>
                <Grid
                  container
                  direction="column"
                  sx={{ pt: 8.75, pl: 7.5, pr: 7.5 }}
                >
                  <Typography
                    variant="h2"
                    sx={{ color: "#424242" }}
                    fontWeight={500}
                    align="center"
                  >
                    광고주 정보
                  </Typography>
                  <Grid container sx={{ pt: 5, pb: 5.625 }} direction="column">
                    <Grid
                      container
                      direction="column"
                      sx={{
                        pt: 4.375,
                        pb: 4.375,
                        pr: 10.375,
                        pl: 10.375,
                      }}
                    >
                      <DefaultLabel name="광고주 이름" />
                      <OutlinedInputDefault
                        value={title.value}
                        disabled={true}
                        onChange={title.onChange}
                        name={"title"}
                        krName={"광고주 이름"}
                      />
                      <Box sx={{ mt: 2.5 }}></Box>
                      <DefaultLabel name="담당 이메일" />
                      <OutlinedInputDefault
                        value={email.value}
                        onChange={email.onChange}
                        name={"banner_name"}
                        krName={"담당 이메일"}
                      />

                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{ mt: 6 }}
                      >
                        <Grid sx={{ width: "50%", pr: 1 }}>
                          <DefaultOutlinedButton
                            variant="outlined"
                            borderColor="primary.main"
                            color="primary"
                            fullWidth
                            sx={{ mt: 5 }}
                            text="취소"
                            onClick={handlePageMove}
                          />
                        </Grid>
                        <Grid sx={{ width: "50%", pl: 1 }}>
                          <DefaultContainedButton
                            color="primary"
                            fullWidth={true}
                            height={56}
                            borderColor="primary.main"
                            fontWeight={500}
                            text="수정"
                            onClick={handleUpdate}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DefaultItem>
            </Grid>
          </Container>
        </Grid>
      )}
    </>
  );
};

export default CompProfile;
